/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var faidToConnectErrorString = "We are having trouble connecting. Please check your internet connection and try again.";
var unknownErrorString = "There was an issue processing your request. Please try again later or contact support if the problem persists.";
var fallbackErrorString = "Operation failed, please try again later.";
var fileTooLargeErrorString = "The size of the file is too large.";

var SpecialHttpStatusCode;
(function (SpecialHttpStatusCode) {
    SpecialHttpStatusCode[SpecialHttpStatusCode["FailedToConnect"] = -1] = "FailedToConnect";
})(SpecialHttpStatusCode || (SpecialHttpStatusCode = {}));
var getErrorMessage = function (error) {
    if (error instanceof HttpError) {
        var errors = error.getErrors();
        return Object.values(errors).flat();
    }
    if (error instanceof Error) {
        return error.message;
    }
    return fallbackErrorString;
};
var HttpError = /** @class */ (function (_super) {
    __extends(HttpError, _super);
    function HttpError(httpStatusCode, json) {
        var _this = _super.call(this) || this;
        Object.setPrototypeOf(_this, HttpError.prototype);
        _this.httpStatusCode = httpStatusCode;
        _this.json = json;
        _this.setErrorMessage();
        return _this;
    }
    HttpError.prototype.setErrorMessage = function () {
        this.message = "HTTP Status Code: ".concat(this.httpStatusCode, ", Details: ").concat(getErrorMessage(this));
    };
    HttpError.prototype.getStatusCode = function () {
        return this.httpStatusCode;
    };
    HttpError.prototype.setJson = function (json) {
        this.json = json;
        this.setErrorMessage();
    };
    HttpError.prototype.getJson = function () {
        if (typeof this.json === "string") {
            return undefined;
        }
        return this.json;
    };
    HttpError.prototype.getErrors = function () {
        if (this.httpStatusCode === SpecialHttpStatusCode.FailedToConnect) {
            return {
                unknown: faidToConnectErrorString,
            };
        }
        if (this.json && this.httpStatusCode < 500) {
            if (typeof this.json === "string") {
                return { unknown: this.json };
            }
            if (this.json.errors) {
                return this.json.errors;
            }
            var defaultError = this.json.detail || this.json.type || this.json.errorCode;
            if (defaultError) {
                return { unknown: defaultError };
            }
        }
        return {
            unknown: unknownErrorString,
        };
    };
    return HttpError;
}(Error));

var NotFoundError = /** @class */ (function (_super) {
    __extends(NotFoundError, _super);
    function NotFoundError(httpStatusCode, json) {
        if (httpStatusCode === void 0) { httpStatusCode = 404; }
        var _this = _super.call(this, httpStatusCode, json) || this;
        Object.setPrototypeOf(_this, NotFoundError.prototype);
        return _this;
    }
    return NotFoundError;
}(HttpError));

var PayloadTooLargeError = /** @class */ (function (_super) {
    __extends(PayloadTooLargeError, _super);
    function PayloadTooLargeError() {
        var _this = _super.call(this, 413, fileTooLargeErrorString) || this;
        Object.setPrototypeOf(_this, PayloadTooLargeError.prototype);
        return _this;
    }
    return PayloadTooLargeError;
}(HttpError));

var UnauthorizedError = /** @class */ (function (_super) {
    __extends(UnauthorizedError, _super);
    function UnauthorizedError() {
        var _this = _super.call(this, 401) || this;
        Object.setPrototypeOf(_this, UnauthorizedError.prototype);
        return _this;
    }
    return UnauthorizedError;
}(HttpError));

function getContentFromResponse(response) {
    return __awaiter(this, void 0, void 0, function () {
        var content;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, response
                            .clone()
                            .json()
                            .catch(function () { return response.clone().text(); })];
                case 1:
                    content = _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a.sent();
                    content = response.statusText;
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/, content];
            }
        });
    });
}
function createErrorFromResponse(status, json) {
    if (status === 401)
        return new UnauthorizedError();
    if (status === 404) {
        return new NotFoundError(status, json);
    }
    if (status === 413) {
        return new PayloadTooLargeError();
    }
    return new HttpError(status, json);
}

var FailToFetchError = /** @class */ (function (_super) {
    __extends(FailToFetchError, _super);
    function FailToFetchError() {
        return _super.call(this, SpecialHttpStatusCode.FailedToConnect) || this;
    }
    return FailToFetchError;
}(HttpError));

export { FailToFetchError, HttpError, NotFoundError, PayloadTooLargeError, UnauthorizedError, createErrorFromResponse, faidToConnectErrorString, fallbackErrorString, fileTooLargeErrorString, getContentFromResponse, getErrorMessage, unknownErrorString };
